// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1rUwc","empty":"ModalGraph_empty__3qlI1"};